import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Linkedin, Facebook, ShieldCheck } from 'lucide-react';
import Logo from './Logo';
import { CONTACT_INFO } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#141618] text-white">
      <div className="max-w-[1280px] mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo light />
            <p className="mt-6 text-[10px] tracking-[0.28em] text-white/70 leading-relaxed">
              CONCIERGE CARE. CLINICAL EXCELLENCE.<br />DELIVERED TO YOU.
            </p>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.3em] text-[#c9a961] font-semibold mb-5">SERVICES</h4>
            <ul className="space-y-3 text-sm text-white/85">
              <li><Link to="/services" className="hover:text-[#c9a961] transition-colors">Mobile Phlebotomy</Link></li>
              <li><Link to="/services" className="hover:text-[#c9a961] transition-colors">BLS CPR Classes</Link></li>
              <li><Link to="/services" className="hover:text-[#c9a961] transition-colors">DNA Testing</Link></li>
              <li><Link to="/services" className="hover:text-[#c9a961] transition-colors">Drug &amp; Urine Screenings</Link></li>
              <li><Link to="/services" className="hover:text-[#c9a961] transition-colors">Corporate &amp; Executive Health</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.3em] text-[#c9a961] font-semibold mb-5">COMPANY</h4>
            <ul className="space-y-3 text-sm text-white/85">
              <li><Link to="/about" className="hover:text-[#c9a961] transition-colors">About Us</Link></li>
              <li><Link to="/for-business" className="hover:text-[#c9a961] transition-colors">For Business</Link></li>
              <li><Link to="/faq" className="hover:text-[#c9a961] transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#c9a961] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.3em] text-[#c9a961] font-semibold mb-5">CONNECT</h4>
            <ul className="space-y-3 text-sm text-white/85">
              <li className="flex items-center gap-3"><Phone size={15} className="text-[#c9a961]" /> {CONTACT_INFO.phone}</li>
              <li className="flex items-center gap-3"><Mail size={15} className="text-[#c9a961]" /> {CONTACT_INFO.email}</li>
              <li className="flex items-center gap-3"><MapPin size={15} className="text-[#c9a961]" /> {CONTACT_INFO.area}</li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              {[
                { Icon: Instagram, label: 'Instagram' },
                { Icon: Linkedin, label: 'LinkedIn' },
                { Icon: Facebook, label: 'Facebook' },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  className="w-9 h-9 rounded-full border border-[#c9a961]/40 flex items-center justify-center text-[#c9a961] hover:bg-[#c9a961] hover:text-[#141618] transition-colors"
                  aria-label={label}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 space-y-6">
          {/* Prominent NPP callout — legally important, must be easy to find */}
          <Link
            to="/hipaa-notice"
            data-testid="footer-hipaa-callout"
            className="flex items-center justify-center gap-3 border border-[#c9a961] text-[#c9a961] hover:bg-[#c9a961] hover:text-[#141618] transition-colors px-6 py-4 tracking-[0.28em] text-[11px] font-semibold group"
          >
            <ShieldCheck size={16} strokeWidth={1.6} className="flex-shrink-0" />
            <span>VIEW OUR HIPAA NOTICE OF PRIVACY PRACTICES</span>
            <span className="opacity-60 group-hover:opacity-100 transition-opacity">&rarr;</span>
          </Link>

          <div className="flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/50">
              &copy; 2024 Aurelia Concierge Wellness Partners, LLC. All Rights Reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-white/50 flex-wrap justify-center">
              <Link to="/hipaa-notice" data-testid="footer-hipaa-link" className="hover:text-[#c9a961] transition-colors">HIPAA Notice</Link>
              <Link to="/policies" data-testid="footer-privacy-link" className="hover:text-[#c9a961] transition-colors">Privacy Policy</Link>
              <Link to="/policies#terms" data-testid="footer-terms-link" className="hover:text-[#c9a961] transition-colors">Terms of Service</Link>
              <Link to="/policies#cancellation" data-testid="footer-cancellation-link" className="hover:text-[#c9a961] transition-colors">Cancellation</Link>
              <Link to="/policies#accessibility" data-testid="footer-accessibility-link" className="hover:text-[#c9a961] transition-colors">Accessibility</Link>
              <Link
                to="/admin"
                className="inline-flex items-center gap-1.5 border border-[#c9a961]/60 text-[#c9a961] hover:bg-[#c9a961] hover:text-[#141618] transition-colors px-3 py-1.5 tracking-[0.22em] text-[10px] font-semibold"
              >
                <ShieldCheck size={12} strokeWidth={1.6} /> ADMIN LOGIN
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
